import { AppScreens, DatabaseIdTypes, PatientSetupTabs } from '../Enums/ChoiceEnums';
import { AppIDs, AppIdType } from "../lib/AppId";
import { combinePaths } from './ChoiceApi';

// Get the URL for the specified screen using the supplied ID values
export function AppUrl(screen:AppScreens, values: AppIDs) : string | undefined
{
    // This sucks: really old code, we need to improve this a bit.
    if (AppScreens.PatientSetup == screen) {
        if (values.appIDs.length == 1) {
            if (AppIdType.PatientEntity == values.appIDs[0].type)
                return patientSetupScreenUrl(DatabaseIdTypes.patient_entity_id,values.appIDs[0].value);
        }
    }

    alert(`Unhandled Choice app screen: ${screen}`);
}


// Generate the URL to get to the Patient Setup page
export function PatientSetupScreen_Deprecated(patientEntityId: number) : string
{
    return OfficeMDScreensPath(`/WindowSetup.htm?WT=Patient%20Setup&Qualifier=entity&WindowID=${patientEntityId}`);
}

// Generate the URL to display the Patient Setup screen
export function patientSetupScreenUrl(idType: DatabaseIdTypes, id: number|string, tab?: PatientSetupTabs) : string | undefined
{
    let url : string;
    switch (idType)
    {
        case DatabaseIdTypes.patient_id:
            url = OfficeMDScreensPath(`/WindowSetup.htm?WT=Patient%20Setup&Qualifier=patient&WindowID=${id}`);
            break;

        case DatabaseIdTypes.entity_id:
        case DatabaseIdTypes.patient_entity_id:
            url = OfficeMDScreensPath(`/WindowSetup.htm?WT=Patient%20Setup&Qualifier=entity&WindowID=${id}`);
            break;

        default:
            alert(`Unknown value type: ${idType}`);
            return;
    }

    if (tab)
    {
        url += `&tab=${tab}`;
    }
    return url;
}


// Add the origin and 'screens' to the destination
function OfficeMDScreensPath(appDest: string) : string
{
    appDest = appDest?.trim();
    if (!appDest || 0 === appDest.length)
        return "";

    // URI for 'OfficeMD'
    const screensPath = `${window.location.origin}/officemd/screens`;

    return combinePaths([screensPath,appDest], true) ?? "";
}

export function patientFlagAssignmentScreenUrl(idType: DatabaseIdTypes, id: number)
{
    return `/officemd/app/setup/PatientFlagAssign/${idType}/${id}`;
}

export function claimEntryScreenUrl(claim_id: number | string)
{
    return `/officemd/screens/ClaimEntry.htm?ClaimID=${claim_id}`;
}

export function claimCommentScreenUrl(claim_id: number | string)
{
    return `/officemd/Comments/CommentsEditor?cgid=claim${claim_id}`;
}

export function loggingURL(patientId: number | string, intakeAssignId: number | string)
{
    return `/officemd/screens/logging.asp?ScreenName=IntakeAssign.htm&LogType=s&StatementId=${patientId}^${intakeAssignId}`;
}
export function mergeIntakeURL(patientId: number | string, intakeAssignId: number | string)
{
    return `../../../screens/intakeAssignResults.htm?pid=${patientId}&iid=${intakeAssignId}`;
}
export function officeCommunicationUrl(patient_id: number | string, claim_id?: number | string)
{
    const baseUrl = "/officemd/screens/mail.asp?new=Y&location=patient_portal&attach=";
    const officeUrl = claim_id ? `${baseUrl}C^${claim_id}~P^${patient_id}` : `${baseUrl}P^${patient_id}`;
    return officeUrl;
}

export function patientCommentScreenUrl(patient_entity_id?: number | string)
{
    return `/officemd/Comments/CommentsEditor?cgid=PEID${patient_entity_id}`;
}
export function providerUrl(provider_id?: number | string)
{
    return `/officemd/screens/provider.asp?WT=Provider Setup&Qualifier=ID&WindowID=${provider_id}`;
}
export function knowledgeOwlUrl(openWindow: boolean = false) : string | void
{
    const window_url = `https://officeemr.knowledgeowl.com/help`;
    if (openWindow)
    {
        openOfficemdWindow(window_url,"KnowledgeOwl");
        return;
    }
    return window_url;
}

export function dataExportRequest(openWindow: boolean = false) : string | void
{
    const window_url = `/officemd/app/ExportDataRequests/ExportDataRequest`;
    if (openWindow)
    {
        openOfficemdWindow(window_url,"ExportDataRequest");
        return;
    }
    return window_url;
}
function openOfficemdWindow(url: string, name: string = "_blank", specs: string = "resizable=true,width=1050,height=900") : void {
    window.open(url, name, specs);
}

export function blankPageUrl(): string
{
    return "/OfficeMD/Screens/Blank.htm";
}